import * as React from 'react';
import { Dimmer, Loader, Segment, Image } from 'semantic-ui-react';
import styles from './Search.module.scss';
import loaderImage from '../../assets/img/short-paragraph.png';
import { SearchResult, SearchResultsHeader, TitleSmall, Pagination, Layout, FilterSmall } from '../../components';
import { Grid } from '@mui/material';
import { ISearchResult, IUrlVariables } from '../../intefaces';
import { appInsights } from '../../AppInsights';
import { DataService, Helper, IDataService, IHelper } from '../../services';

interface ISearchProps {
    q: any;
}

interface ISearchState {
    searchResult: ISearchResult[];
    resultsCount: number;
    currentResults: number;
    sortingDesc: boolean;
    sortingRelevance: boolean;
    searchSkip: number;
    searchText: string;
    showResult: boolean;
    isLoading: boolean;
    viewSelectedValue: string;
    fuzzySearch: string;
}


class Search extends React.Component<ISearchProps, ISearchState> {
    private _dataService: IDataService = new DataService();
    private _helpers: IHelper = new Helper();

    constructor(props: any) {
        super(props);
        this.state = {
            searchResult: [],
            searchText: '*',
            sortingDesc: true,
            sortingRelevance: false,
            searchSkip: 0,
            resultsCount: 0,
            currentResults: 0,
            showResult: false,
            isLoading: false,
            viewSelectedValue: '',
            fuzzySearch: 'true'
        }
    }

    componentDidMount() {
        this.getSearchDetails();
        window.history.pushState(null, 'Search', window.location.pathname + this.props.q);
    }

    componentDidUpdate(prevProps: ISearchProps, prevState: ISearchState) {
        if (prevProps !== this.props) {
            window.history.pushState(null, 'Search', window.location.pathname + this.props.q);
        }
    }

    public render() {
        appInsights.trackPageView({
            uri: window.location.href + this.props.q,
            name: 'Search'
        });
        return (
            <Layout>
                <TitleSmall />
                <Grid container spacing={1} className={styles.search}>
                    <Grid item xs={3}>
                        <FilterSmall onSearch={this.clickHandle} searchText={this.state.searchText} applyFitlers={() => this.applyFilters()} fuzzySearch={this.state.fuzzySearch} />
                    </Grid>
                    <Grid item xs={9}>
                        <SearchResultsHeader currentResults={this.state.searchSkip} totalResults={this.state.resultsCount} callSearchApi={(e: any, f: any) => this.callSearchApiSorting(e,f)} viewSelected={(e: any) => this.shareSelected(e)} sortRelevance={this.state.sortingRelevance} sortDesc={this.state.sortingDesc}/>
                        {this.state.isLoading ?
                            <Segment>
                                <Dimmer active inverted>
                                    <Loader>Preparing Files</Loader>
                                </Dimmer>
                                <Image src={loaderImage} />
                            </Segment> :
                            <>
                                <SearchResult searchResult={this.state.searchResult} searchText={this.state.searchText} showResult={this.state.showResult} viewSelected={this.state.viewSelectedValue} />
                                {this.state.resultsCount > 0 ? <Pagination resultsCount={this.state.resultsCount} resultsSkip={this.state.searchSkip} callSearchApi={(e: any) => this.callSearchApiPagination(e)} />  : <div />}

                            </>
                        }
                    </Grid>
                </Grid>
            </Layout>
        )
    }

    private applyFilters() {
        this.callApi(this.state.searchText, 10, 0, this.state.sortingDesc, this.state.sortingRelevance);
    }

    private shareSelected(e: any) {
        this.setState({
            viewSelectedValue: e
        });
    }

    private getSearchDetails() {

        const fromResults = sessionStorage.getItem("fromResults");
        const savedState = sessionStorage.getItem("searchState");

        if (fromResults && savedState) {
            sessionStorage.removeItem("fromResults");
            const state = JSON.parse(savedState);
            this.setState({
                searchText: state.searchText,
                sortingDesc: state.sortingDesc,
                sortingRelevance: state.sortingRelevance,
                searchSkip: state.searchSkip
            });

            this.callApi(state.searchText, 10, state.searchSkip, state.sortingDesc, state.sortingRelevance);
            return;
        }

        
        if (this.props.q !== null && this.props.q !== '') {
            let urlsplitted: IUrlVariables = this._helpers.UrlSpliting(this.props.q);

            this.setState({
                searchText: urlsplitted.searchQuery || '*',
                fuzzySearch: urlsplitted.fuzzy || 'true',
                searchSkip: 0
            });

            this.callApi(urlsplitted.searchQuery || '*', 10, 0, this.state.sortingDesc, this.state.sortingRelevance);
        }
    }

    private async callSearchApiSorting(sortingOrder: any, sortingRelevance: boolean = false) {
        this.setState({
            sortingDesc: sortingOrder,
            sortingRelevance: sortingRelevance
        });
        await this.callApi(this.state.searchText, 10, 0, sortingOrder, sortingRelevance);
    }

    private callSearchApiPagination(e: any) {

        let pageNumber: number = parseInt(e);

        if (!isNaN(pageNumber)) {
            let skipSize: number = pageNumber === 1 ? 0 : (pageNumber * 10) - 10;
            this.callApi(this.state.searchText, 10, skipSize, this.state.sortingDesc, this.state.sortingRelevance);
        }

        window.scroll(0,0);
    }

    private async callApi(searchText: string, searchSize: number, searchSkip: number, sortingDesc: boolean, relevanceOrder: boolean = false) {
        this.setState({
            isLoading: true
        });

        try {
            let results = await this._dataService.CallSearchApi(searchText, searchSize, searchSkip, sortingDesc, relevanceOrder);
            let currRes = results[0].count < 10 ? results[0].count : (results[0].count < searchSkip + 10) ? results[0].count : searchSkip + 10;

            this.setState({
                searchText: searchText,
                searchResult: results,
                resultsCount: results[0].count,
                searchSkip: searchSkip,
                currentResults: currRes,
                showResult: true
            });

            sessionStorage.setItem("searchState", JSON.stringify({
                searchText: searchText,
                searchSkip: searchSkip,
                sortingDesc: sortingDesc,
                sortingRelevance: relevanceOrder,
                resultsCount: results[0].count
            }));
        }
        catch (e) {
            let err = new Error("Call Search API: " + e);
            appInsights.trackException({
                exception: err,
                severityLevel: 3
            });
        }

        this.setState({
            isLoading: false,
        });

        window.scrollTo(0, 0);
    }

    private clickHandle = (data: any) => {
        sessionStorage.removeItem("searchState"); 
        this.callApi(data, 10, 0, this.state.sortingDesc, this.state.sortingRelevance);
        this.setState({
            searchText: data
        });
        
    }
}

export default Search;
